import { render, staticRenderFns } from "./DashboardIndex.vue?vue&type=template&id=d771f6a6&"
import script from "./DashboardIndex.vue?vue&type=script&lang=js&"
export * from "./DashboardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports